
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class MaterialOutGrid extends Serenity.EntityGrid<MaterialOutRow, any> {
        protected getColumnsKey() { return 'Sales.MaterialOut'; }
        protected getDialogType() { return MaterialOutDialog; }
        protected getIdProperty() { return MaterialOutRow.idProperty; }
        protected getInsertPermission() { return MaterialOutRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialOutRow.localTextPrefix; }
        protected getService() { return MaterialOutService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row); 
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {
            
            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(39);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[39].AutoPosting;

            this.editItem(<MaterialOutRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 39,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}